module.exports = __webpack_public_path__ + "static/img/pricing.53d5f215.svg";